export default __webpack_public_path__ + "static/story_dark-d721a773020dd6042e82b1192334867e.png";